module.exports = __webpack_public_path__ + "static/media/pre-rastreabilidade.d29da04e.md";